export default "__VITE_ASSET__15e5c6ef__"